module.exports = __webpack_public_path__ + "static/media/dermatology2.f729cce5.webp";